import { switchMap } from "rxjs/operators";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseComponent } from "app/shared/common/base-component";

@Component({
  selector: "detect-browser-iphone",
  templateUrl: "./detect-browser.component.html",
  styleUrls: ["./detect-browser.component.scss"],
})
export class DetectBrowserIphone extends BaseComponent implements OnInit {
  errMessageVisible: boolean = false;
  errMessage: string = "";

  constructor(
    protected router: Router,
    private activeRoute: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {}

  public openSafari() {
    window.location.href = "itms-apps://itunes.apple.com/app/id1146562112";
  }
}
